import Star from '@mui/icons-material/Star';
import { Rating } from '@mui/material';
import * as React from 'react';

export interface StarRatingProps {
  onChange?: (_event: React.ChangeEvent<{}>, newValue: number) => void;
  rating: number;
  readOnly?: boolean;
}

const StarRating: React.FC<StarRatingProps> = ({ onChange, rating, readOnly }) => {
  return (
    <Rating
      size="medium"
      name="rate-the-sheet"
      readOnly={readOnly}
      value={rating}
      onChange={(e, val) => onChange(e, val ?? rating)} // default value is null onChange
      icon={<Star />}
    />
  );
};

export default StarRating;
